import Request from "./request";
import consts from "@/consts.js";

// 线路管理
async function fetch(data) {
  return Request("get", "api/distribution-users/", data);
}

async function fetchAllForSelect(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/distribution-users/select", data, false, false, true);
}

// 删除数据
async function del(id) {
  return Request("delete", "api/distribution-users/delete/" + id);
}

// 编辑或新建（有id为编辑，没有id为新建）
async function save(id, data) {
  if (id) {
    return Request("post", "api/distribution-users/edit?id=" + id, data);
  } else {
    return Request("post", "api/distribution-users/add", data);
  }
}

// 获取绑定门店
async function selectShops(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request("get", "api/distribution-users/get-distribution-user-shop-list", data);
}

// 获取绑定门店
async function addShops(data) {
  if (data.shop_id) {
    return Request("post", "api/distribution-users/add-shop", data);
  } else {
    return Request("post", "api/distribution-users/add-shop-batch", data);
  }
}

// 获取绑定门店
async function removeShops(data) {
  if (data.shop_id) {
    return Request("delete", "api/distribution-users/remove-shop", data);
  } else {
    return Request("delete", "api/distribution-users/remove-shop-batch", data);
  }
}

  async function imports(id,file) {// 导入
    var data = new FormData();
    data.append("excel", file);
    data.append("stock_id", id);
    return Request('post', "api/distribution-users/import", data);
}

export default {
  fetch,
  fetchAllForSelect,
  del,
  save,
  selectShops,
  addShops,
  removeShops,
  imports,
};
